export default "__VITE_ASSET__Cp7eYAP6__"